import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { environment } from './../../../../../../../../environments/environment';
import { AuthService } from './../../../../../../auth/auth.service';


@Component({
	selector: 'kt-play-video',
	templateUrl: './play-video.component.html',
	styleUrls: ['./play-video.component.scss']
})
export class PlayVideoComponent implements OnInit {
	private token: string;
	public  link;
	public loadingVisible: boolean

	constructor(public dialogRef: MatDialogRef<PlayVideoComponent>,
		private authService: AuthService,
		@Inject(MAT_DIALOG_DATA) private data: any) { }

	ngOnInit() {
		this.loadingVisible = true;
		this.token = this.authService.getUser().tokenHW;
		this.obtenerVideo(this.data);

		setTimeout(() => {
			this.loadingVisible = false;

		}, 4000);
	}

	obtenerVideo(file) {
		let startTime = file.start.replace('-', '').replace(' ', '').replace(':', '');
		startTime = startTime.replace('-', '').replace(' ', '').replace(':', '');

		let endTime = file.stop.replace('-', '').replace(' ', '').replace(':', '');
		endTime = endTime.replace('-', '').replace(' ', '').replace(':', '');

		this.link = `${environment.HOWEN_API}/vss/apiPage/ReplayVideo.html?token=${this.token}&deviceId=${file.deviceID}&chs=${file.channel}&st=${startTime}&et=${endTime}&wnum=1&panel=0`;
	}


	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
